import { render, staticRenderFns } from "./EditablePublish.vue?vue&type=template&id=394bd5f2&scoped=true"
import script from "./EditablePublish.vue?vue&type=script&lang=js"
export * from "./EditablePublish.vue?vue&type=script&lang=js"
import style0 from "./EditablePublish.vue?vue&type=style&index=0&id=394bd5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394bd5f2",
  null
  
)

export default component.exports